/* eslint-disable no-restricted-globals */

import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import { updateForwardedParams } from "src/utils/urlParams";
import {
  isAddonStoreEligible,
  isEligibleForBiomarkersCrossSellMed,
  isNoomSummitEligible,
  isShowMetabolicForMenCrossSellMedAfterSermorelin,
  isShowMetabolicForWomenCrossSellMedAfterSermorelin,
  isShowSermorelinCrossSellMedBeforeMetabolic,
  isUpsEx360MedActive,
  isUpsEx363MedBeforeBiomarkersActive,
  isUpsEx363MedReplaceBiomarkersActive,
  isUpsEx364MedBeforeMetabolicActive,
} from "src/utils/userSegment/features";
import { isInApp } from "src/utils/userSegment/in-app";
import { SessionStorageKey } from "src/utils/constants";
import { setNoomSessionStorage } from "src/utils/noomSessionStorage";
import goto from ".";

export type OffersParams = {
  userId?: string;
  acceptedCoursePackOffer?: boolean;
};

export type CollapsibleHeaderUrlParams = {
  showEmailReminder?: "noomPremium" | "noomSummit" | "snackDelivery" | false;
};

function setTelehealthCrossSellSession() {
  setNoomSessionStorage(SessionStorageKey.isNewPatient, true);
  setNoomSessionStorage(SessionStorageKey.isTelehealthBuyflow, true);
}

export default {
  noomPremium() {
    goto.layer("noom-premium");
  },
  inAppNoomPremium() {
    goto.layer("noom-premium-in-app-upgrade");
  },
  addOns({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder ?? null,
    });
    goto.layer("addons");
  },

  probioticsDelivery() {
    goto.layer("probiotics-delivery");
  },

  hrtSurvey() {
    goto.layer("hrt-survey");
  },

  fastForwardTrial({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder ?? null,
    });
    goto.layer(`fast-forward`);
  },

  postSignupCrossSellExit() {
    if (
      isUpsEx360MedActive() ||
      isUpsEx363MedBeforeBiomarkersActive() ||
      isUpsEx363MedReplaceBiomarkersActive() ||
      isUpsEx364MedBeforeMetabolicActive()
    ) {
      goto.telehealthEnrollmentSetup();
      return;
    }

    if (isNoomSummitEligible()) {
      goto.layer("noom-summit");
      return;
    }
    if (isAddonStoreEligible()) {
      goto.addOns({ showEmailReminder: false });
      return;
    }
    if (isInApp()) {
      goto.nativePurchaseComplete();
      return;
    }
    goto.enrollment({});
  },

  postSermorelinCrossSellExit() {
    if (isShowMetabolicForMenCrossSellMedAfterSermorelin()) {
      setTelehealthCrossSellSession();
      goto.layer("offers-shop-metabolic-for-men");
      return;
    }

    if (isShowMetabolicForWomenCrossSellMedAfterSermorelin()) {
      setTelehealthCrossSellSession();
      goto.layer("offers-shop-metabolic-for-women");
      return;
    }

    goto.shopIntake();
  },

  postMetabolicCrossSellExit() {
    if (isShowSermorelinCrossSellMedBeforeMetabolic()) {
      goto.postSignupCrossSellExit();
      return;
    }

    if (
      isUpsEx363MedBeforeBiomarkersActive() &&
      isEligibleForBiomarkersCrossSellMed()
    ) {
      setTelehealthCrossSellSession();
      goto.layer("offers-shop-biomarkers-test-kit");
      return;
    }
    goto.postSignupCrossSellExit();
  },

  /**
   * Where a prescription shop product goes once bought, rather than closing the
   * webview like the OTC flows do. Sets the telehealth flag for the standalone
   * flow, which has nothing setting it upstream.
   */
  shopIntake() {
    setNoomSessionStorage(SessionStorageKey.isTelehealthBuyflow, true);
    goto.telehealthEnrollmentSetup();
  },
};
